import React from 'react';
import PropTypes from 'prop-types';
import markdownToSafeHtml from '../common/markdownToSafeHtml';

/*
  ObjectFieldTemplate for react-jsonschema-form
  - Renders a simple hero block for the root object using title/description
  - Wraps each top-level property content in a card-like section
  - Uses plain CSS classes styled in formViewer.css
*/

const ObjectFieldTemplate = (props) => {
  const {
    title,
    description,
    properties,
    idSchema,
    formContext
  } = props;

  const headerImage = formContext && formContext.headerImage;
  const cloudinaryBase = 'https://res.cloudinary.com/dqlpbfemc/image/fetch/t_form_banner';
  // Use encodeURI so protocol and slashes remain intact; Cloudinary "fetch" supports this form
  const transformedHeaderImage = headerImage
    ? `${cloudinaryBase}/${encodeURI(headerImage)}`
    : '';
  const buttonColor = (formContext && formContext.buttonColor) || '#5986ff';

  const lighten = (hex, factor = 0.9) => {
    const normalized = hex.replace('#', '');
    const full = normalized.length === 3
      ? normalized.split('').map(c => c + c).join('')
      : normalized;
    const r = parseInt(full.substring(0, 2), 16);
    const g = parseInt(full.substring(2, 4), 16);
    const b = parseInt(full.substring(4, 6), 16);
    const mix = c => Math.round(c + (255 - c) * factor);
    const toHex = n => n.toString(16).padStart(2, '0');
    return `#${toHex(mix(r))}${toHex(mix(g))}${toHex(mix(b))}`;
  };

  const isRoot = idSchema && idSchema.$id === 'root';
  const heroStyle = headerImage ? {} : { backgroundColor: lighten(buttonColor, 0.92) };

  return (
    <div className={isRoot ? 'rjsf-object rjsf-object--root' : 'rjsf-object'}>
      {isRoot && (
        <div className="form-hero" style={heroStyle}>
          {headerImage && (
            <div className="form-hero__image">
              <img alt={title} src={transformedHeaderImage} />
            </div>
          )}
          <div className="form-hero__content">
            {title && <h1 className="form-hero__title">{title}</h1>}
            {description && (
              <div
                id="root__description"
                className="form-hero__description"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: markdownToSafeHtml(description) }}
              />
            )}
          </div>
        </div>
      )}

      <div className="form-sections">
        {properties.map(prop => (
          <div key={prop.name} className="form-section">
            {prop.content}
          </div>
        ))}
      </div>
    </div>
  );
};

ObjectFieldTemplate.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  properties: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    content: PropTypes.element.isRequired,
  })).isRequired,
  idSchema: PropTypes.shape({
    $id: PropTypes.string,
  }).isRequired,
  formContext: PropTypes.shape({
    headerImage: PropTypes.string,
    buttonColor: PropTypes.string,
  }),
};

ObjectFieldTemplate.defaultProps = {
  title: '',
  description: '',
  formContext: {},
};

export default ObjectFieldTemplate;
